import React, { Component } from "react";
import Content from "../components/Content";
import ContactUsFrom from "../components/Froms/ContactUsFrom";

export default class ContactUs extends Component {
  render() {
    return (
      <Content className="bg-grey">
        <div className="row">
          <div className="col-md-6">
            <h2>
              Contact Us
              <hr/>
            </h2>
          </div>
          <div className="col-md-6">
            <p>Learn how Lumio’s platform can engage your audience and transform your business.
              Fill out the form below and we'll contact you as soon as possible.</p>

            <ContactUsFrom/>

          </div>
        </div>
      </Content>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/ContactUs.js